import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button, Input } from "@/components/Kit";
import { Wallet } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhcmslMjBncmFkaWVudCUyMGdlb21ldHJpYyUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzg0Njg2Mjg3fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-obsidian/60" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-md bg-cyan flex items-center justify-center">
              <Wallet size={20} weight="fill" className="text-black" />
            </div>
            <span className="font-heading font-extrabold text-xl tracking-tighter">Ledgerly</span>
          </div>
          <div>
            <h2 className="font-heading font-extrabold text-4xl tracking-tighter leading-none max-w-sm">
              Take command of every dollar.
            </h2>
            <p className="text-[#A1A1AA] mt-4 max-w-sm">
              Track income and expenses, set budgets, and visualize your money across currencies.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-sm animate-fade-up">
          <h1 className="font-heading font-extrabold text-3xl tracking-tighter mb-2">Sign in</h1>
          <p className="text-[#A1A1AA] text-sm mb-8">Enter your credentials to access your dashboard.</p>
          <form onSubmit={submit} className="space-y-4">
            <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com" required data-testid="login-email" />
            <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" required data-testid="login-password" />
            <Button type="submit" disabled={loading} className="w-full" data-testid="login-submit-btn">
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </form>
          <p className="text-sm text-[#A1A1AA] mt-6">
            No account?{" "}
            <Link to="/register" className="text-cyan hover:underline" data-testid="go-register">Create one</Link>
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-md border border-white/10 bg-white/[0.03] px-3 py-2">
            <span className="text-xs text-[#71717A]">Demo</span>
            <span className="text-xs num text-cyan">admin@finance.com / admin123</span>
          </div>
        </div>
      </div>
    </div>
  );
}
